import Component from 'component';

class EpiFormCustomChoiceField extends Component {
  constructor(el) {
    super(el);
  }
  setupDefaults() {
    this.dom = {
      customInputs: this.$el.find('input'),
      customLabels: this.$el.find('label')
    }
    this.selectedClass = 'is-selected';
    this.initInputs();

  }
  addListeners() {
    this.dom.customInputs.on('change', ::this.onInputChange);
  }
  initInputs() {
    this.dom.customInputs.each((index, element) => {
      if ($(element).prop('checked')) {
        $(element).siblings('label').addClass(this.selectedClass);
      }
    });
  }

  onInputChange(e) {
    const $input = $(e.target);
    const $label = $input.siblings('label');

    if ($input.attr('type') === 'radio') {
      this.dom.customLabels.removeClass(this.selectedClass);
      $label.addClass(this.selectedClass);
    }

    if ($input.attr('type') === 'checkbox' && $label.hasClass(this.selectedClass)) {
      $label.removeClass(this.selectedClass);
    } else if ($input.attr('type') === 'checkbox' && !$label.hasClass(this.selectedClass)) {
      $label.addClass(this.selectedClass);
    }
  }
}
export default EpiFormCustomChoiceField



// WEBPACK FOOTER //
// ./src/cc/js/components/EpiFormCustomChoiceField.js